import { Stack, Typography, useTheme } from "@mui/material";

import { RHFDate, RHFRadioSingle } from "@app/components";
import { Strings } from "@app/constants";

export const Section1 = ({ methods }: any) => {
  const theme = useTheme();
  const errors = methods?.formState?.errors?.carInfo?.insurance;

  return (
    <Stack
      sx={{
        flex: 1,
        minWidth: { xs: "100%", sm: "48%" },
        border: `1px solid ${
          errors ? theme.palette.error.main : theme.palette.grey[300]
        }`,
        borderRadius: 1,
        flexDirection: "column",
        p: 2,
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 500, fontSize: 20, mb: 1 }}>
        {Strings.step.carInfo.insurance}
      </Typography>
      <Stack
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent={"space-between"}
        alignItems={{ xs: "start", md: "center" }}
      >
        <Typography>{Strings.step.carInfo.insuranceAvailable}</Typography>
        <Stack
          flexDirection={"row"}
          flexWrap={"wrap"}
          width={{ xs: "100%", md: "auto" }}
          justifyContent={"space-between"}
        >
          <RHFRadioSingle
            name={`carInfo.insurance.isInsuranceAvailable`}
            value={Strings.step.carInfo.yes}
            label={Strings.step.carInfo.yes}
          />
          <RHFRadioSingle
            name={`carInfo.insurance.isInsuranceAvailable`}
            value={Strings.step.carInfo.no}
            label={Strings.step.carInfo.no}
          />
        </Stack>
      </Stack>
      {errors?.isInsuranceAvailable && (
        <Typography color="error" variant="caption" sx={{ mt: 0.5, fontWeight: 500 }}>
          {errors.isInsuranceAvailable.message}
        </Typography>
      )}

      <Stack
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent={"space-between"}
        alignItems={{ xs: "start", md: "center" }}
        mt={1}
      >
        <Typography>{Strings.step.carInfo.insuranceType}</Typography>
        <Stack
          flexDirection={"row"}
          flexWrap={"wrap"}
          width={{ xs: "100%", md: "auto" }}
          justifyContent={"space-between"}
        >
          <RHFRadioSingle
            name={`carInfo.insurance.insuranceType`}
            value={Strings.step.carInfo.comprehensive}
            label={Strings.step.carInfo.comprehensive}
          />
          <RHFRadioSingle
            name={`carInfo.insurance.insuranceType`}
            value={Strings.step.carInfo.thirdParty}
            label={Strings.step.carInfo.thirdParty}
          />
        </Stack>
      </Stack>
      {errors?.insuranceType && (
        <Typography color="error" variant="caption" sx={{ mt: 0.5, fontWeight: 500 }}>
          {errors.insuranceType.message}
        </Typography>
      )}

      <Stack
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent={"space-between"}
        alignItems={{ xs: "start", md: "center" }}
        mt={1}
      >
        <Typography>{Strings.step.carInfo.expiryDate}</Typography>
        <Stack
          flexDirection={"row"}
          mt={{ xs: 1, md: 0 }}
          width={{ xs: "100%", md: "auto" }}
        >
          <RHFDate
            sx={{
              width: { xs: "100%", md: 200 },
            }}
            name={`carInfo.insurance.expiryDate`}
            label={Strings.step.carInfo.expiryDate}
          />
        </Stack>
      </Stack>

      <Stack
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent={"space-between"}
        alignItems={{ xs: "start", md: "center" }}
        mt={1}
      >
        <Typography>{Strings.step.carInfo.anyClaimsMade}</Typography>
        <Stack
          flexDirection={"row"}
          flexWrap={"wrap"}
          width={{ xs: "100%", md: "auto" }}
          justifyContent={"space-between"}
        >
          <RHFRadioSingle
            name={`carInfo.insurance.anyClaimsMade`}
            value={Strings.step.carInfo.yes}
            label={Strings.step.carInfo.yes}
          />
          <RHFRadioSingle
            name={`carInfo.insurance.anyClaimsMade`}
            value={Strings.step.carInfo.no}
            label={Strings.step.carInfo.no}
          />
        </Stack>
      </Stack>
      {errors?.anyClaimsMade && (
        <Typography color="error" variant="caption" sx={{ mt: 0.5, fontWeight: 500 }}>
          {errors.anyClaimsMade.message}
        </Typography>
      )}
    </Stack>
  );
};
